<template>
<div class="register1">

  <vue-headful
    title="Designbox"
    description="Designbox"
/>

<section class="section register1">
    <div class="container">
    <div class="columns is-centered">
    <div class="column is-6 has-text-centered">
    <h1 v-if="!generic">{{ $t("register") }}</h1>
    <h1 v-if="generic"><img v-show="site_logo" :src="site_logo" :alt="site_title" /><span v-show="! site_title_as_alt">{{ site_title }}</span></h1>
    <h2 v-if="generic">{{ $t("register") }}</h2>
    <p>{{ $t("register-details") }}</p><br>
    <form @submit.prevent="validateBeforeSubmit">

        <b-field :label="$t ('email')"
            :type="{'is-danger': errors.has('email')}"
            :message="errors.first('email')">
            <b-input v-model="user.email" name="email" v-validate="'required|email'" />
        </b-field>

        <b-field grouped>
            <b-field :label="$t ('password')" expanded
                :type="{'is-danger': errors.has('password1')}"
                :message="errors.first('password1')">
                <b-input type="password" v-model="user.password1" name="password1" v-validate="'required|min:8'" />
            </b-field>

            <b-field :label="$t ('password-repeat')" expanded
                :type="{'is-danger': errors.has('confirm-password')}"
                :message="confirmPasswordErrorMessage"
                >
                <b-input type="password" v-model="user.password2" name="confirm-password"
                    v-validate="{ required: true, is: user.password1 }" />
            </b-field>
        </b-field>

        <b-field grouped>
            <b-field :label="$t ('firstname')" expanded
                :type="{'is-danger': errors.has('first_name')}"
                :message="errors.first('first_name')">
                <b-input type="text" v-model="user.first_name" name="first_name" v-validate="'required'" />
            </b-field>

            <b-field :label="$t ('middlename')" expanded
                :type="{'is-danger': errors.has('middle_name')}"
                :message="errors.first('middle_name')"
                v-if="showMiddleName"
                >
                <b-input type="text" v-model="user.middle_name" name="middle_name"/>
            </b-field>

            <b-field :label="$t ('lastname')" expanded
                :type="{'is-danger': errors.has('last_name')}"
                :message="errors.first('last_name')">
                <b-input type="text" v-model="user.last_name" name="last_name" v-validate="'required'" />
            </b-field>
        </b-field>

        <button type="submit" class="button is-primary" v-if="!getRegisterActive"> {{ $t("register") }} </button>
    </form>
    </div>
    </div>
    </div>
</section>
</div>
</template>

<script>
import { mapGetters } from 'vuex'
import config         from '@/config'

export default {
    name: 'Register',
    props: ["location"],
    data: function(){
        return{
            user:{
                email: '',
                password1: '',
                password2:'',
                first_name:'',
                middle_name:'',
                last_name:''
            },
            showMiddleName: config.showMiddleName,
            confirmPasswordErrorMessage: "",
            generic: config.generic,
            site_title: config.title,
            site_logo: config.logo,
            site_title_as_alt: config.title_as_alt,
        }
    },
    computed: {
        ...mapGetters(['getUserLoading',"getRegisterActive"]),
    },
    watch: {
        "user.password2": function (value) {
            if (!value) {
                this.confirmPasswordErrorMessage = this.$t ("repeat-password-required")
            } else if (value != this.user.password1) {
                this.confirmPasswordErrorMessage = this.$t ("repeat-password-missmatch")
            } else
                this.confirmPasswordErrorMessage = ""
        }
    },
    methods: {
        validateBeforeSubmit() {
            var self= this;
            this.$validator.validateAll().then((result) => {
                if (result) {
                    this.$store.dispatch ("register",{user:this.user,self:self})
                } else {
                    if (!this.user.password2) {
                        this.confirmPasswordErrorMessage = this.$t ("repeat-password-required")
                    }
                }
            })
        },
    }
}
</script>

<style>

</style>